import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import getConfig from '@ringcentral/rwc-utils/src/config';

import { SdkContextProvider } from '@low/containers/sdk-context';
import DynamicManager from '@low/containers/dynamic-manager';

const RwcApp = ({ VCAppGetter }) => {
    const config = useMemo(getConfig, []);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const VCApp = useMemo(VCAppGetter, []);

    return (
        <SdkContextProvider>
            <DynamicManager>
                <VCApp config={config} />
            </DynamicManager>
        </SdkContextProvider>
    );
};

RwcApp.propTypes = {
    VCAppGetter: PropTypes.func.isRequired,
};

export default RwcApp;
